import { createSelector } from 'reselect';
import {
    get,
    isEqual
} from 'lodash';
import {
    VOID_BULK_FAILURE,
    VOID_BULK_LOAD,
    VOID_BULK_SUCCESS,
    VOID_FAILURE,
    VOID_LOAD,
    VOID_SUCCESS
} from './voidActions';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let newState;
    switch (action.type) {
        case VOID_LOAD:
            newState = {
                ...state,
                voids: {
                    ...state.voids,
                    [action.id]: {
                        error: null,
                        loading: true,
                        success: false
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;

        case VOID_SUCCESS:
            newState = {
                ...state,
                voids: {
                    ...state.voids,
                    [action.id]: {
                        error: null,
                        loading: false,
                        success: true
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;

        case VOID_FAILURE: {
            newState = {
                ...state,
                voids: {
                    ...state.voids,
                    [action.id]: {
                        error: action.error,
                        loading: false,
                        success: false
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;
        }

        case VOID_BULK_LOAD:
            newState = {
                ...state,
                error: null,
                bulkVoidLoading: true,
                bulkVoidSuccessful: false
            };

            return isEqual(state, newState) ? state : newState;

        case VOID_BULK_SUCCESS:
            newState = {
                ...state,
                bulkVoidLoading: false,
                bulkVoidSuccessful: true
            };

            return isEqual(state, newState) ? state : newState;

        case VOID_BULK_FAILURE:
            newState = {
                ...state,
                error: action.error,
                bulkVoidLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getVoidEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'void')
);

export const getVoids = createSelector(
    getVoidEntity,
    (entity) => get(entity, 'voids')
);

export const getVoidObjectById = createSelector(
    getVoids,
    (state, id) => id,
    (voids, id = '') => get(voids, id)
);

export const getIsVoidLoadingById = createSelector(
    (state, id) => getVoidObjectById(state, id),
    (transactionVoidObject) => get(transactionVoidObject, 'loading')
);

export const getIsVoidSuccessfulById = createSelector(
    (state, id) => getVoidObjectById(state, id),
    (transactionVoidObject) => get(transactionVoidObject, 'success')
);

export const getVoidErrorById = createSelector(
    (state, id) => getVoidObjectById(state, id),
    (transactionVoidObject) => get(transactionVoidObject, 'error')
);

export const getVoidErrorMessageById = createSelector(
    (state, id) => getVoidErrorById(state, id),
    (error) => get(error, 'message')
);

export const getIsBulkVoidSuccessful = createSelector(
    getVoidEntity,
    (entity) => get(entity, 'bulkVoidSuccessful')
);

export const getBulkVoidError = createSelector(
    getVoidEntity,
    (entity) => get(entity, 'error')
);

export const getBulkVoidErrorMessage = createSelector(
    getBulkVoidError,
    (error) => get(error, 'message')
);

export const getIsBulkVoidLoading = createSelector(
    getVoidEntity,
    (entity) => get(entity, 'bulkVoidLoading')
);
